import { InfoWrapper, MainContainer } from './selected-shop-details.style'
import { Typography, theme } from 'antd'
import { Avatar } from 'components/avatar/avatar'
import { useTouchDetector, useTranslate } from 'utils'
import { CheckOutlined, CopyOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { useCurrentShop } from 'api'
import { HorizontalContainer } from 'components/styled'
const { Text, Paragraph } = Typography

export const SelectedShopDetails = () => {

    //hooks:
    const { __ } = useTranslate()
    const { token: {
        fontSizeLG,
        colorTextDescription,
        colorBgContainer
    }} = theme.useToken()

    const { data: currentShop } = useCurrentShop()

    return currentShop ? (

            <MainContainer>

                <InfoWrapper>

                    {/* name */}
                    <Text
                        style={{
                            fontSize: fontSizeLG,
                            fontFamily: 'inter-medium'
                        }}
                    >
                        {currentShop.name}
                    </Text>

                    {/* Domain */}
                    {currentShop.url ? (
                        <LabelValue
                            label={__`domain`}
                            value={(currentShop.domain ?? currentShop.url).replace('https://', '').replace('www.', '')}
                        ></LabelValue>
                    ) : <></>}

                    {/* Admin ID */}
                    <LabelValue
                        label={__`admin_id`}
                        value={currentShop.id}
                    ></LabelValue>

                    {/* Shopify ID */}
                    <LabelValue
                        label={__`shopify_id`}
                        value={currentShop.externalId}
                    ></LabelValue>

                </InfoWrapper>

                {/* avatar */}
                <Avatar
                    image={currentShop.image.path}
                    color={colorTextDescription}
                    backgroundColor={colorBgContainer}
                    size='small'
                />

            </MainContainer>
    ) : <></>

}

type Props = {
    label: string
    value: string
}

const LabelValue = ({ label, value }: Props) => {

    const { __ } = useTranslate()
    const { isTouchscreen } = useTouchDetector()
    const { token: { fontSizeSM, paddingXXS, colorInfoActive, colorTextDescription }} = theme.useToken()

    const [ isHovered, setIsHovered ] = useState(false)

    return (
        <HorizontalContainer style={{ justifyContent: 'flex-start' }}>

            <Paragraph
                style={{
                    fontSize: fontSizeSM,
                    color: colorTextDescription,
                    width: 'fit-content',
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                {label}:
            </Paragraph>

            <Paragraph
                style={{
                    width: 'fit-content',
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center',
                }}
                copyable={{
                    icon: [
                        <CopyOutlined  key={1} style={{ opacity: isHovered || isTouchscreen ? 1 : 0, padding: paddingXXS, color: colorTextDescription }}/>,
                        <CheckOutlined key={2} style={{ opacity: isHovered || isTouchscreen ? 1 : 0, padding: paddingXXS, color: colorInfoActive      }}/>
                    ],
                    tooltips: [__`copy`, __`copied`],
                    text: value
                }}
                title={value}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <Text style={{
                    maxWidth: 200,
                    fontSize: fontSizeSM,
                    color: colorTextDescription,
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden'
                }}>
                    {value}
                </Text>
            </Paragraph>

        </HorizontalContainer>
    )

}
